<template>
  <widget
    @closed="$emit('closed')"
    @search="toggleSearch"
    title="documenti lavoratori"
    icon="mdi-note-multiple"
    :bgColor="colors.blue"
    dark
    searchButton
    scroll
  >
    <transition name="fade" appear>
      <search-bar v-if="searchBtn" @search="updateData"></search-bar>
    </transition>
    
    <v-list dense>
      <v-list-item>
        <v-list-item-content class="pa-0">
          <v-list-item-title :color="colors.primarycolor" class="text-capitalize text-little">
            Buste paga
          </v-list-item-title>
          <v-list-item-subtitle class="text-little">
            <span class="mx-2">Pubblicate:</span>
            <span class="green--text"
              >SI
              {{ items && items.bustePaga && items.bustePaga.pubblicati }}</span
            >
            <span class="ml-2 red--text"
              >NO
              {{
                items && items.bustePaga && items.bustePaga.nonPubblicati
              }}</span
            >
            <span class="mx-2">Letti:</span>
            <span class="red--text"
              >NO
              {{ items && items.bustePaga && items.bustePaga.nonLetti }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon
            class="mt-3"
            :color="colors.primarycolor"
            dark
            @click="
              $router.push({
                path: '/company/documents/lav',
                query: { active: 'bp', codiceAzienda: currentCompany },
              })
            "
          >
            mdi-eye
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="pa-0">
          <v-list-item-title class="text-capitalize text-little">
            CU
          </v-list-item-title>
          <v-list-item-subtitle class="text-little">
            <span class="mx-2">Pubblicate:</span>
            <span class="green--text"
              >SI {{ items && items.cu && items.cu.pubblicati }}</span
            >
            <span class="ml-2 red--text"
              >NO {{ items && items.cu && items.cu.nonPubblicati }}</span
            >
            <span class="mx-2">Letti:</span>
            <span class="red--text"
              >NO {{ items && items.cu && items.cu.nonLetti }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon
            class="mt-3"
            :color="colors.primarycolor"
            dark
            @click="
              $router.push({
                path: '/company/documents/lav',
                query: { active: 'cu', codiceAzienda: currentCompany },
              })
            "
          >
            mdi-eye
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="pa-0">
          <v-list-item-title class="text-capitalize text-little">
            Generici
          </v-list-item-title>
          <v-list-item-subtitle class="text-little">
            <span class="mx-2">Pubblicate:</span>
            <span class="green--text"
              >SI
              {{ items && items.generici && items.generici.pubblicati }}</span
            >
            <span class="ml-2 red--text"
              >NO
              {{
                items && items.generici && items.generici.nonPubblicati
              }}</span
            >
            <span class="mx-2">Letti:</span>
            <span class="red--text"
              >NO {{ items && items.generici && items.generici.nonLetti }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon
            class="mt-3"
            :color="colors.primarycolor"
            dark
            @click="
              $router.push({
                path: '/company/documents/lav',
                query: { active: 'ge', codiceAzienda: currentCompany },
              })
            "
          >
            mdi-eye
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </widget>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Widget from "./Widget.vue";
import mixin from "@/mixin";
import SearchBar from "./SearchBar.vue";

export default {
  name: "doclavrecazi",
  mixins: [mixin],
  components: {
    Widget,
    SearchBar,
  },
  mounted() {
    this.fetchData();
  },
  data() {
    return {
      searchBtn: false,
    };
  },
  methods: {
    updateData(da, a) {
      this.fetchData({ da, a });
    },
    toggleSearch() {
      this.searchBtn = !this.searchBtn;
    },
    ...mapActions({
      fetchData: "widget/fetchDoclavrecazi",
    }),
  },
  computed: {
    ...mapGetters({
      items: "widget/doclavrecazi",
      currentCompany: "widget/currentCompany",
    }),
  },
};
</script>

<style>
</style>